import { Directive, ElementRef, HostListener, Input, NgZone, OnInit, output } from "@angular/core";

@Directive({
    "selector": "[dragTarget]",
    standalone: true
})
export class DragTargetDirective implements OnInit {
    readonly drop = output<[
    ElementRef,
    any[]
]>({ alias: 'handledrop' });

    constructor (private el: ElementRef, private ngZone: NgZone) { }

    ngOnInit (): void {
        this.ngZone.runOutsideAngular(() => {
            this.el.nativeElement.addEventListener("dragenter", this.onDragEnter.bind(this));
            this.el.nativeElement.addEventListener("dragover", (evt: DragEvent) => { evt.preventDefault(); });
            this.el.nativeElement.addEventListener("dragleave", this.onDragLeave.bind(this));
        });
    }

    @HostListener("drop", ["$event"]) onDrop (event: any): void {
        event.preventDefault();
        if (!this.el.nativeElement.classList.contains("drag-active")) { return; }

        let elems = document.querySelectorAll(".drag-active");
        for (let i = 0; i < elems.length; i++) {
            elems[i].classList.remove("drag-active");
            elems[i].classList.remove("over");
        }

        let children = this.el.nativeElement.children;
        for (let i = 0; i < children.length; i++) {
            children[i].style.pointerEvents = "auto";
        }

        let body = document.querySelector("body");
        let scrollTop = document.querySelector("#scroll-top");
        let scrollBottom = document.querySelector("#scroll-bottom");
        if (scrollTop) { body.removeChild(scrollTop); }
        if (scrollBottom) { body.removeChild(scrollBottom); }

        let data = <any[]>JSON.parse(event.dataTransfer.getData("text"));
        this.drop.emit([this.el, data]);
    }

    private onDragEnter (event: any): void {
        event.preventDefault();
        if (!this.el.nativeElement.classList.contains("drag-active")) { return; }
        this.el.nativeElement.classList.add("over");
        let children = this.el.nativeElement.children;
        for (let i = 0; i < children.length; i++) {
            children[i].style.pointerEvents = "none";
        }
    }

    private onDragLeave (): void {
        this.el.nativeElement.classList.remove("over");
        let children = this.el.nativeElement.children;
        for (let i = 0; i < children.length; i++) {
            children[i].style.pointerEvents = "auto";
        }
    }
}
